module.exports = __webpack_public_path__ + "img/LKA.9018cbe9.svg";